<template>
  <IQOS
    required
    :title="
      in_reserve
        ? $t('halls_tables.reserve_title')
        : $t('navbar.' + $route.name)
    "
    :warning="
      in_reserve && reservedTablesCount == 0
        ? ' - ' + $t('halls_tables.reserve_missing')
        : null
    "
    :class="!editing ? 'iqos-transparent' : ''"
    :systemDependency="in_reserve ? 'reserve' : null"
  >
    <div class="halls-description mt-16" v-if="editing">
      <p class="comment v1-grey-7-color" v-if="!in_reserve">
        {{ $t("halls_tables.description") }}
      </p>
      <p class="comment v1-grey-7-color" :class="{
        'orange-4-color': in_reserve && reservedTablesCount == 0
      }" v-else>
        {{ $t("halls_tables.reserve_description") }}
      </p>
    </div>
    <div
      class="halls-description no-halls-comment"
      v-if="!editing && !sections.length"
    >
      <p class="iqos-comment v1-grey-7-color">
        {{ $t("halls_tables.no_halls") }}
      </p>
    </div>
    <div v-if="in_reserve && !editing && reservedTablesCount == 0">
      <p class="iqos-comment v1-grey-7-color">
        {{ $t("halls_tables.reserve_description") }}
      </p>
    </div>

     <TableSelector 
      class="mb-16" 
      v-for="(section,sindex) in cafe.sections" 
      :key="sindex" 
      :section="section"
      mode="reserve" 
      :section_index="sindex"/>

    <BaseDivider class="mt-16" color="v1-grey-4"/>
    <p class="qrw-paragraph-md red-4-color mt-16">
      {{ $t('halls_tables.reserve_red_desc') }}
    </p>
    <p class="qrw-paragraph-xs v1-grey-10-color mt-16" v-if="editing && in_reserve">
      {{ $t("halls_tables.reserve_description2") }}
    </p>
    
    <IQOSActions
      :editing="editing"
      @edit="showEditUI"
      @cancel="hideEditUI"
      @accept="onEditFinish"
      v-if="!in_reserve"
    />
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from "@/components/IQOSActions.vue";

import BlackInput from "@/components/BlackInput.vue";

import DashboardButton from "@/components/DashboardButton.vue";

import TableCell from "@/components/halls/TableCell.vue";
import TableSelector from "@/components/halls/TableSelector.vue"

export default {
  components: {
    IQOS,
    IQOSActions,
    BlackInput,
    DashboardButton,
    TableCell,
    TableSelector
  },
  data() {
    return {
      editing: false,
      sections: [],

      is_reserve_valid: true,
    };
  },
  props: {
    in_reserve: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    onEditFinish() {
      this.clearTombhalls();

      if (this.in_reserve && !this.reservedTablesCount) {
        // this.$store.dispatch("showError", "reserve_tables");
        return false;
      }

      this.is_reserve_valid = this.isReserveSettingsValid();

      if (!this.is_reserve_valid) return;

      if (!this.in_reserve) this.editing = false;

      this.$store.commit("setCafeSections", this.sections);
      this.$store.dispatch("saveCafe");

      this.$store.dispatch("auditlog/write", {
        type: "change_tables",
        payload: {
          halls_count: this.sections.length
        },
      });
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    reset() {
      this.sections = this.cafe.sections.slice();

      for (let i = 0; i < this.sections.length; i++) {
        this.onSectionTablesCountChanged(i);
      }
    },
    addHall() {
      this.sections.push({
        name: null,
        tables: 1,
        tables_list: [
          {
            places_count: null,
            x_pos: 2,
            y_pos: 2,
            width: 4,
            height: 4
          },
        ],
      });
    },
    clearTombhalls() {
      for (let i = 0; i < this.sections.length; i++) {
        this.sections[i].tables_list = this.sections[i].tables_list.slice(
          0,
          this.sections[i].tables
        );
      }
    },
    onSectionTablesCountChanged(index) {
      const new_count = this.sections[index].tables;

      if (!this.sections[index].tables_list) {
        this.sections[index].tables_list = [];
      }

      const tables_difference =
        new_count - this.sections[index].tables_list.length;

      if (tables_difference > 0) {
        for (let i = 0; i < tables_difference; i++) {
          this.sections[index].tables_list.push({
            places_count: null,
            for_reserve: false,
            x_pos: 2,
            y_pos: 2,
            width: 4,
            height: 4
          });
        }
      }
    },
    toggleTableReserve(section_index, table_index, value) {
      if (!this.in_reserve || !this.editing) return;

      if (!this.sections[section_index].tables_list[table_index].places_count)
        return;

      this.$set(
        this.sections[section_index].tables_list[table_index],
        "for_reserve",
        value
      );

      this.onEditFinish();
    },
    setTableName(section_index, table_index, value) {
      this.$set(
        this.sections[section_index].tables_list[table_index],
        "name",
        value
      );
    },
    setTableRoomType(section_index, table_index, value) {
      this.$set(
        this.sections[section_index].tables_list[table_index],
        "room_type",
        value
      );
    },
    showReserveTable(table) {
      if (this.editing) return true;
      if (!this.in_reserve) return true;

      if (!this.reservedTablesCount) return true;

      return table.for_reserve;
    },
    isReserveSettingsValid() {
      if (!this.in_reserve) return true;

      const invalid_tables = this.sections
        .reduce((acc, s) => acc.concat(s.tables_list), [])
        .filter((t) => t.for_reserve && !t.places_count);

      return invalid_tables.length == 0;
    },
    hasReserveTables(section) {
      if (!section.tables_list) return false;
      return !!section.tables_list.find((t) => t.for_reserve && t.places_count);
    },
    getSectionReserveTables(section) {
      if (!this.in_reserve)
        return section.tables_list.map((t, i) => {
          return {
            table_item: t,
            real_index: i,
          };
        });

      return section.tables_list
        .map((t, i) => {
          return {
            table_item: t,
            real_index: i,
          };
        })
        .filter((t) => t.table_item && this.showReserveTable(t.table_item));
    },
  },
  mounted() {
    this.reset();

    if (this.in_reserve) {
      this.showEditUI();
    }
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    isHotel() {
      return this.$store.getters.isHotel;
    },
    tableCellState() {
      if (this.editing && !this.in_reserve) return "edit";

      return "static";
    },
    reservedTablesCount() {
      return this.sections
        .reduce((acc, s) => acc.concat(s.tables_list), [])
        .filter((t) => t.for_reserve).length;
    },
  },
};
</script>

<style scoped>
.input-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-content: center;
}
.halls-input {
  margin-right: 1.2vh;
  border: 1px solid transparent;
  background: #1d1d1d;
  text-align: left !important;
}

.halls-input.light,
.tables-input.light {
  background: #ededed;
  color: #1d1d1d;
}

.tables-input {
  width: 11vh;
  border: 1px solid transparent;
  background: #1d1d1d;
}

.iqos-cancel {
  height: 4vh;
  margin-left: 1.2vh;
  width: auto;
  /* margin-top: 0.2vh; */
  cursor: pointer;
}
.tables-row {
  justify-content: flex-start;
  display: flex;
  width: 100%;
  flex-flow: row wrap;
}

.table-item:nth-child(6n) {
  margin-right: 0;
}

.table-item:last-child {
  /* margin-right: 0; */
}
.table-item {
  margin-top: 8px;
  margin-right: 2%;
  text-align: center;
  width: 15%;
}
.table-item-reserve {
  margin-top: 8px;
  margin-right: 1.3333333333333333vh;
  text-align: center;
  /* flex-basis: 17%; */
  cursor: pointer;
  width: 8%;
}
.table-item-reserve:nth-child(11n) {
  margin-right: 0;
}

.hall-container {
  border-bottom: 1px solid #908f8d;
  margin-bottom: 2vh;
  padding-bottom: 2vh;
}

.hall-container.last-hall {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.halls-description {
  width: 100%;
  border-bottom: 1px solid #464646;
  margin-bottom: 2vh;
  padding-bottom: 2vh;
}

.no-halls-comment {
  padding: 0;
  margin: 0;
}
.hall-title {
  background: #464646;
  border-radius: 0.4444444444444444vh;
  width: 100%;
  font-size: 2vh;
  line-height: 2.3333333333333335vh;
  color: #ededed;
  padding: 0.6666666666666666vh 0;
}
.hall-title-active {
  background: #129b81;
}
</style>
